
"use client";

import { useState } from "react";
import type { Quote } from "@/lib/types";
import QuoteForm from "@/components/quote-form";
import QuoteList from "@/components/quote-list";
import { Card } from "@/components/ui/card";
import AppNavigation from "@/components/navigation";

// We use a partial quote here because the tracking_id is not generated by the public user.
type DraftQuote = Omit<Quote, "id" | "tracking_id">;

export default function QuotePage() {
  const [quotes, setQuotes] = useState<Quote[]>([]);

  const handleAddQuote = (quote: Omit<Quote, "id" | "tracking_id">) => {
    const newQuote: Quote = { 
        ...quote, 
        id: Date.now().toString(),
    };
    setQuotes((prevQuotes) => [...prevQuotes, newQuote]);
  };

  const handleDeleteQuote = (id: string) => {
    setQuotes((prevQuotes) => prevQuotes.filter((quote) => quote.id !== id));
  };
  
  return (
    <main className="min-h-screen bg-background p-4 sm:p-8">
       <AppNavigation />
      <div className="max-w-7xl mx-auto mt-6">
        <header className="text-center mb-8">
          <h1 className="text-3xl sm:text-4xl font-bold text-primary mb-2 font-headline">
            Cotizador RzCell
          </h1>
          <p className="text-lg text-muted-foreground">
            Cotiza la reparación de tu celular de forma rápida y sencilla.
          </p>
        </header>
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-start">
          <div className="lg:col-span-2">
            <Card className="shadow-lg">
              <QuoteForm onAddQuote={handleAddQuote} />
            </Card>
          </div>
          <div className="lg:col-span-1">
            <QuoteList
              quotes={quotes}
              onDeleteQuote={handleDeleteQuote}
            />
          </div>
        </div>
        <footer className="text-center mt-12 py-6 border-t">
          <p className="text-sm text-muted-foreground">
            © {new Date().getFullYear()} RzCell. Todos los derechos
            reservados.
          </p>
        </footer>
      </div>
    </main>
  );
}
